export const ENDPOINTS = {
  listTemplates: '/templates',
  createVideo: '/videos'
};
